import { z } from 'zod';
/**
 * Intégration Klaviyo — Paramètres → Klaviyo (`06` §11.4). Une connexion au
 * compte, partagée par les fonctions qui l'utilisent (aujourd'hui la
 * synchronisation de la catégorie d'abonné Recharge).
 */
/** `GET /api/klaviyo/settings` : la clé n'est jamais renvoyée, seulement sa présence. */
export const klaviyoSettingsSummarySchema = z.object({
    apiKeyConfigured: z.boolean(),
});
/** `PUT /api/klaviyo/settings` — clé API privée (`pk_…`). */
export const klaviyoSettingsUpdateBodySchema = z
    .object({
    apiKey: z.string().trim().min(1).max(2_000),
})
    .strict();
//# sourceMappingURL=klaviyo.js.map